import { atom } from 'jotai';

// Configuration UserTour.js
export const userTourConfigAtom = atom({
  token: import.meta.env.VITE_USERTOUR_TOKEN || 'cmd4bpj7700px3ol05b7psofx',
  userId: '',
  userProperties: {} as Record<string, unknown>,
  groupId: '',
  groupProperties: {} as Record<string, unknown>,
});
